import React from 'react';
import * as PropTypes from 'prop-types';

const Spacer = ({ orientation, spacing }) => {
  const initialSpacing =
    typeof spacing === 'string' ? { xSmall: spacing } : { ...spacing };
  const finalSpacing = { ...initialSpacing };

  if (!finalSpacing.xSmall) {
    finalSpacing.xSmall = 0;
  }

  if (!finalSpacing.small !== true) {
    finalSpacing.small = finalSpacing.xSmall;
  }

  if (!finalSpacing.medium !== true) {
    finalSpacing.medium = finalSpacing.small;
  }

  if (!finalSpacing.large !== true) {
    finalSpacing.large = finalSpacing.medium;
  }

  if (!finalSpacing.xLarge !== true) {
    finalSpacing.xLarge = finalSpacing.large;
  }

  return (
    <div className="spacer">
      {/* language=CSS */}
      <style jsx>
        {`
          .spacer {
            height: ${orientation === 'vertical' ? finalSpacing.xSmall : 0};
          }

          @media (min-width: 576px) {
            .spacer {
              height: ${orientation === 'vertical' ? finalSpacing.small : 0};
            }
          }

          @media (min-width: 768px) {
            .spacer {
              height: ${orientation === 'vertical' ? finalSpacing.medium : 0};
            }
          }

          @media (min-width: 992px) {
            .spacer {
              height: ${orientation === 'vertical' ? finalSpacing.large : 0};
            }
          }

          @media (min-width: 1200px) {
            .spacer {
              height: ${orientation === 'vertical' ? finalSpacing.xLarge : 0};
            }
          }
        `}
      </style>
    </div>
  );
};

Spacer.propTypes = {
  orientation: PropTypes.oneOf(['vertical', 'horizontal']).isRequired,
  spacing: PropTypes.oneOfType([
    PropTypes.shape({
      xSmall: PropTypes.string,
      medium: PropTypes.string,
      large: PropTypes.string,
      xLarge: PropTypes.string,
    }),
    PropTypes.string,
  ]).isRequired,
};

Spacer.defaultProps = {};

export default Spacer;
